/**
 * Görsel URL'indeki non-ASCII (ör. Türkçe "ı", "ş", "ç") karakterleri encode eder.
 *
 * NEDEN: next.config'de `images.unoptimized: true` olduğundan Next.js Image ham
 * src'yi hem <img>'e hem de `priority` görsellerin ürettiği `Link: <url>; rel=preload`
 * HTTP response header'ına koyar. Header değerleri Latin-1 (ByteString, <=255) olmak
 * zorunda; ham "ı" (U+0131 = 305) => "Cannot convert argument to a ByteString" hatası.
 * Bu hata SSR yanıtını bozar => hydration mismatch => client baştan render => boş flash.
 *
 * encodeURI, zaten encode edilmiş %XX sequence'larını bozmaz (pratikte idempotent) ve
 * URL yapı karakterlerini (/ : ? & = #) korur. Tarayıcı ham "ı"'yı da aynı şekilde
 * encode ettiğinden (%C4%B1) görsel yine doğru dosyayı yükler.
 */
export const encodeImageUrl = (src: string): string => {
  try {
    return encodeURI(src);
  } catch {
    return src;
  }
};
